<template src="./Vehicle.html"></template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import CommandCell from "@/components/CommandCellTemplate/CommandCellTemplate";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions, mapGetters } = createNamespacedHelpers("vehicle");
import { MESSAGES } from "@/utils/constants";
import { notify, notifyApiError } from "@/utils/notification-helper";
import DialogBox from "@/components/DialogBox";
import ViewDropdown from "@/components/ViewDropdown";
import { saveExcel } from "@progress/kendo-vue-excel-export";
import VehicleIconTemplate from "./VehicleIconTemplate";
import moment from "moment-timezone";
import { USER_ROLES } from "@/utils/constants";
import { isAllowedUser } from "@/utils/auth-helper";
import TaxExpiry from "./TaxExpiry";
import InsuranceEndDate from "./InsuranceEndDate";
import PermitEndDate from "./PermitEndDate";
import FcExpiryDate from "./FcExpiryDate";
import EmissionExpiryDate from "./EmissionExpiryDate"
import MaintenanceDueDate from "./MaintenanceDueDate"

export default {
  components: {
    DialogBox,
    ViewDropdown,
    TaxExpiry,
    InsuranceEndDate,
    PermitEndDate,
    FcExpiryDate,
    EmissionExpiryDate,
    MaintenanceDueDate
  },
  data: function () {
    return {
      gridHeight: window.innerHeight - 150,
      // addoredit: false,
      gridData: [],
      skip: 0,
      take: 25,
      pageSize: 25,
      vehicleId: null,
      vendorValue: "",
      pageable: {
        previousNext: true,
        pageSizes: [5, 10, 25, 100, 500],
        pageSize: 10,
      },
      defaultVal: { name: "All", id: "All" },
      searchText: "",
      add: true,
      sort: [{ field: "vehicleRtoNum", dir: "asc" }],
      viewColumns: [],
      // fuelTypes: [ 
      //   { value: 'P', title: "Petrol" },
      //   { value: 'D', title: "Diesel" },
      //   { value: 'L', title: "LPG" },
      //   { value: 'E', title: "Electric" },
      // ],
      columns: [
        {
          hidden: false,
          field: "rtoNumber",
          title: "Vehicle RTO No",
          width: "150px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "model",
          title: "Model",
          width: "120px",
          checked: true,
          defaultSelected: false,
        },
        {
          hidden: false,
          field: "vehicleType",
          cell: VehicleIconTemplate,
          title: "Vehicle Type",
          width: "100px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "taxExpiryDate",
          title: "Tax Expiry Date",
          width: "120px",
          cell: TaxExpiry,
          checked: true,
          defaultSelected: false,
        },
        {
          hidden: false,
          field: "insuranceExpiry",
          title: "Insurance End Date",
          width: "150px",
          cell: InsuranceEndDate,
          checked: true,
          defaultSelected: false,
        },
        {
          hidden: false,
          field: "permitEnd",
          title: "Permit End Date",
          width: "125px",
          cell: PermitEndDate,
          checked: true,
          defaultSelected: false,
        },
        {
          hidden: false,
          field: "fcExpiryDate",
          title: "FC Expiry Date",
          width: "110px",
          cell: FcExpiryDate,
          checked: true,
          defaultSelected: false,
        },
        {
          hidden: false,
          field: "emissionExpiry",
          title: "Emission Expiry Date",
          width: "160px",
          cell: EmissionExpiryDate,
          checked: true,
          defaultSelected: false,
        },
        {
          hidden: false,
          title: "Maintenance Due Date",
          field: "maintenanceDueDate",
          width: "180px",
          cell: MaintenanceDueDate,
          checked: true,
          defaultSelected: false,
        },
        {
          hidden: false,
          title: "IMEI Number",
          field: "imei",
          width: "180px",
          checked: true,
          defaultSelected: false,
        },
        {
          hidden: false,
          title: "Driver",
          field: "driverID",
          cell: this.getDriverName,
          width: "100px",
          checked: true,
          defaultSelected: false,
        },  
        {
          hidden: false,
          title: "Fuel Type",
          field: "fuelType",
          cell: this.fuelType,
          width: "80px",
          checked: true,
          defaultSelected: false,
        },
        // {
        //   hidden: false,
        //   title: "Vehicle Type",
        //   field: "vehicleType",
        //   cell: this.getVehicleType,
        //   width: "180px",
        //   checked: true,
        //   defaultSelected: false,
        // },
        {
          hidden: false,
          cell: CommandCell,
          title: "Actions",
          width: "150px",
          locked: true,
          ignoreCheckbox: true,
        },
      ],
      dataItems: [],
      allowVendor: false,
      //  defaultVal: { name: 'All', id: 'all'},
    };
  },
  props: {
    selectedVehicleColumns: Array,
  },
  methods: {
    cellFunction: function (h, tdElement, props) {
      const field = props.field;
      var date = props.dataItem[field];
      if (!date) {
        return h("td", {}, "");
      }
      return h("td", {}, moment(date).format("DD/MM/YYYY"));
    },
    getDriverName: function (h, tdElement, props) {
      const id = props.dataItem[props.field];
      const driverInfo = this.$store.getters["vehicle/getDrivers"].find(
        (vcl) => vcl.id === id
      );
      console.log("drivername",driverInfo)
      return h("td", {}, driverInfo ? driverInfo.fullName : "");
    },
    getVehicleType: function (h, tdElement, props) {
      const id = props.dataItem[props.field];
      const vehicleType = this.getVehicleTypes.find(
        (vcl) => vcl.id === id
      );
      return h(
        "td",
        {},
        vehicleType ? vehicleType.name + ` (${vehicleType.type})` : id
      );
    },
    fuelType: function (h, tdElement, props) {
      const fType = props.dataItem[props.field];
      const fuelType = this.getVehicleFuelTypes.find(ft => ft.id === parseInt(fType));
      return h("td", {}, fuelType ? fuelType.name : fType);
    },
    openWindow: function () {
      this.$router.push({ name: "VehicleForm", params: { add: true } });
      // this.$router.push("/vehicle-management/add");
    },
    sortChangeHandler: function (e) {
      this.sort = e.sort;
    },

    pageChangeHandler: function (event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    showAdd: function () {
      this.add = true;
    },
    remove: function (item) {
      this.dataItems = item;
      this.$refs.form.openWindow();
    },
    exportExcel() {
      console.log("#test",this.columns)
      saveExcel({
        data: this.vehicleData,
        fileName: "vehicle",
        columns: this.columns,
      });
    },
    downloadTemplate() {
      saveExcel({
        data: [],
        fileName: "sampleTemplate",
        columns: this.columns,
      });
    },
    OkMethod() {
      let item = this.dataItems;
      // var t = this;
      // console.log(this.vehicleId);
      return this.$store
        .dispatch("vehicle/deleteVehicle", item.dataItem.id)
        .then(() => {
          notify(MESSAGES.DELETE_SUCCESS);
          // this.getDataOnload();
        })
        .catch(notifyApiError);
    },
    edit: function (item) {
      console.log("Triggering edit... ", item);
      this.$store.dispatch("vehicle/editVehicle", item.dataItem);
    },
    async getDataOnload() {
      console.log('vehicleData',this.vehicleDataVal)
      await this.$store.dispatch("vehicle/vehicleModelDropdown");
      // if (!this.$route.params.cancel) { }
    },
    columnChange(e) {
      if (e.item.checked) {
        e.item.hidden = false;
      } else {
        e.item.hidden = true;
      }
      this.$store.commit("vehicle/setSelectedVehicleColumns", [
        ...this.columns,
      ]);
      localStorage.setItem(
        "vehicleManagementColumns",
        JSON.stringify(this.viewColumns)
      );
    },
    ...mapActions(["getSearchData"]),
    Search() {
      console.log(this.items);
      this.vehicleData = [];
    },
    returnColumns(){
      return this.columns;
    }
  },
  computed: {
    ...mapState({
      vehicleData: (state) => state.vehicleData,
      loader: (state) => state.loader
    }),
    ...mapGetters([
      "getDrivers",
      "getBillingTypes",
      "getVehicle",
      "getVehicleTypes",
      "getVehicles",
      "getVehicleFuelTypes"
    ]),
    total() {
      return this.vehicleDataVal ? this.vehicleDataVal.length : 0;
    },
    filter() {
      return {
        logic: "or",
        filters: [
          {
            field: "vehicleRtoNum",
            operator: "contains",
            value: this.searchText,
          },
          {
            field: "seatCapacity ",
            operator: "contains",
            value: this.searchText,
          },
          { field: "model ", operator: "contains", value: this.searchText },
        ],
      };
    },
    // allowVendor() {
    //   return this.$store.state.allowVendorSelection;
    // },
    vehicleDataVal() {
      return this.gridvehicleData.filter(
        
        (data) =>
          JSON.stringify(data).replace(/\s/g, '').toUpperCase()
            .indexOf(this.searchText.replace(/\s/g, '').toUpperCase()) !== -1
      );
      
    },
    items: {
      get: function () {
        return orderBy(
          this.vehicleDataVal.slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
    validateUserForAddVehicle: () => isAllowedUser([USER_ROLES.SUPER_ADMIN, USER_ROLES.TENANT_ADMIN]), 
    gridvehicleData(){
     return this.$store.state.vehicles;
    }
  },
  mounted() {
    this.getDataOnload();

    const eListColumns = JSON.parse(
      localStorage.getItem("vehicleManagementColumns")
    );
    if (!eListColumns) {
      this.viewColumns = [...this.columns];
      this.$store.commit("vehicle/setSelectedVehicleColumns", [
        ...this.columns,
      ]);
    } else {
      let items = [];
      this.columns.map((col, i) => {
        const obj = eListColumns.find((c) => c.field === col.field);
        // Ignoring last column
        if (i < this.columns.length - 1)
          if (obj) {
            items.push({
              ...col,
              hidden: obj.hidden,
              checked: obj.checked,
              defaultSelected: obj.defaultSelected,
              ignoreCheckbox: obj.ignoreCheckbox,
            });
          } else {
            items.push({ ...col });
          }
      });

      // adding ignored last column
      items.push(this.columns[this.columns.length - 1]);
      this.viewColumns = items;
      this.columns = items;
      this.$store.commit("vehicle/setSelectedVehicleColumns", items);
    }
  },
  created: function () {
    this.unsubscribe = this.$store.subscribe(async (mutation) => {
      if (mutation.type == "setInitialData") {
        // this.loadVendor();
        // await this.$store.dispatch("vehicle/fetchVehicles");
        // await this.$store.dispatch("vehicle/fetchBillingTypes");
        this.getDataOnload();
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  beforeMount() {
    // this.loadVendor();
    // this.viewColumns = [ ...this.columns ];
  },
};
</script>
<style lang="scss" scoped>
  .search_mobile{width: 15% !important; border-radius: 5px;}
@media only screen and (max-width: 768px) {
  .search_mobile{width: 40% !important;}  
}
</style>
